var map = {
	"./en": [
		6848,
		"src_locale_en_ts"
	],
	"./en.ts": [
		6848,
		"src_locale_en_ts"
	],
	"./it": [
		9121,
		"src_locale_it_ts"
	],
	"./it.ts": [
		9121,
		"src_locale_it_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4887;
module.exports = webpackAsyncContext;